module.exports = __webpack_public_path__ + "static/img/shangchuan.531ed486.png";